export default {
  de: {
    add: 'Partei hinzufügen',
    categories: 'Kategorien',
    statuses: 'Status',
    name: 'Name',
  },
};
